'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../styles/templates/collection.scss');

require('../sections/template-search');

require('../sections/index-blog');

require('../sections/index-products');

(0, _themeSections.load)(['template-search', 'index-blog', 'index-products']);

// Search sections